import React from 'react';
import { Tabs, Tab, Table, Button, Badge } from 'react-bootstrap';
import { PlusOutlined } from '@ant-design/icons';
import {
    VAI_TRO_BAI_BAO,
    LOAI_TAP_CHI,
    VAI_TRO_DE_TAI,
    CAP_DE_TAI,
    XEP_LOAI_KET_QUA,
    VAI_TRO_SANG_CHE,
    CAP_GIAI_THUONG,
    LOAI_SACH,
    VAI_TRO_SACH,
    BAC_HOC_VIEN,
    TRACH_NHIEM_HD
} from '@app/utils/define';
import { formatDateTimeWithoutHour } from '@app/utils/helper';
import { RenderApprovalBadge, RenderFileMinhChung, RenderActionButtons } from './HelperComponents';

const AchievementTabs = ({
    activeTab,
    onSelectTab,
    nhanVien,
    baiBao,
    deTai,
    sangChe,
    giaiThuong,
    sach,
    huongDanHocVien,
    giaiThuongDaoTao,
    isAdmin,
    setSelectedItem,
    setActiveModal,
    handleDeleteItem,
    handleApprove,
    handleRevoke,
    openRejectModal
}) => {
    return (
        <Tabs 
            activeKey={activeTab} 
            onSelect={onSelectTab} 
            id="achievements-tabs" 
            className="custom-tabs border-bottom px-4 pt-3 bg-light"
        >


            {/* TAB BÀI BÁO KHOA HỌC */}
            <Tab eventKey="baibao" title="2.1 Bài báo công bố">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách bài báo khoa học đã công bố</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('BaiBao'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo bài báo
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên bài báo/báo cáo KH</th>
                                <th>Số tác giả</th>
                                <th>Là tác giả (chính/liên hệ/phụ)</th>
                                <th>Tên tạp chí hoặc kỷ yếu khoa học/ ISSN hoặc ISBN</th>
                                <th>Loại Tạp chí quốc tế uy tín: ISI, Scopus (IF, Qi)</th>
                                <th>Số lần trích dẫn (không tính tự trích dẫn)</th>
                                <th>Tập, số, trang</th>
                                <th>Tháng, năm công bố</th>
                                <th className="d-print-none">Minh chứng</th>
                                <th className="d-print-none">Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {baiBao.map((b, idx) => (
                                <tr key={b.id}>
                                    <td>{idx + 1}</td>
                                    <td>
                                        <strong>{b.tenBaiBao}</strong>
                                        {b.linkBaiBao && (
                                            <div className="d-print-none" style={{ fontSize: '11px' }}>
                                                <a href={b.linkBaiBao} target="_blank" rel="noopener noreferrer">Link online</a>
                                            </div>
                                        )}
                                    </td>
                                    <td>{b.soTacGia}</td>
                                    <td>
                                        {(() => {
                                            const val = b.vaiTroTacGia;
                                            if (val === 1 || val === '1') return 'Chính';
                                            if (val === 2 || val === '2') return 'Liên hệ';
                                            if (val === 3 || val === '3') return 'Phụ';
                                            const found = VAI_TRO_BAI_BAO.find(o => o.value === val);
                                            if (found) {
                                                if (found.label.includes('chính')) return 'Chính';
                                                if (found.label.includes('liên hệ')) return 'Liên hệ';
                                                if (found.label.includes('phụ') || found.label.includes('Đồng tác giả')) return 'Phụ';
                                                return found.label;
                                            }
                                            return val || 'Phụ';
                                        })()}
                                    </td>
                                    <td>
                                        {b.tenTapChi}
                                        {b.issnIsbn && (
                                            <>
                                                <br />
                                                <span className="text-muted" style={{ fontSize: '11px' }}>ISSN: {b.issnIsbn}</span>
                                            </>
                                        )}
                                    </td>
                                    <td>
                                        {(() => {
                                            const val = b.loaiTapChi;
                                            const v = Number(val);
                                            if (v === 1) return 'Bài báo trên tạp chí ISI/Scopus uy tín (Q1/Q2)';
                                            if (v === 2) return 'Bài báo trên tạp chí quốc tế uy tín khác (Q3/Q4)';
                                            if (v === 3) return 'Bài báo trên tạp chí quốc tế khác';
                                            if (v === 4) return 'Bài báo trên tạp chí khoa học quốc gia uy tín';
                                            if (v === 5) return 'Bài báo trên các tạp chí khoa học quốc gia uy tín';
                                            const found = LOAI_TAP_CHI.find(o => o.value === val);
                                            return found ? found.label : val;
                                        })()}
                                    </td>
                                    <td>{b.soLanTrichDan !== null && b.soLanTrichDan !== undefined ? b.soLanTrichDan : 0}</td>
                                    <td>{b.tapSoTrang || ''}</td>
                                    <td>{b.nam}</td>
                                    <td className="d-print-none">
                                        <RenderFileMinhChung jsonString={b.fileMinhChung} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderApprovalBadge type="BaiBao" item={b} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="BaiBao" 
                                            item={b}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {baiBao.length === 0 && (
                                <tr>
                                    <td colSpan={12} className="text-center text-muted">Không có bài báo khoa học nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Tab>

            {/* TAB ĐỀ TÀI CÁN BỘ */}
            <Tab eventKey="detai" title="2.2 Nhiệm vụ KHCN (Đề tài)">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách các Đề tài nghiên cứu khoa học</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('DeTai'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo đề tài
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên nhiệm vụ khoa học và công nghệ (CT, ĐT...)</th>
                                <th>CN/PCN/TK</th>
                                <th>Mã số và cấp quản lý</th>
                                <th>Thời gian thực hiện</th>
                                <th>Thời gian nghiệm thu (ngày, tháng, năm)/Xếp loại KQ</th>
                                <th className="d-print-none">Minh chứng</th>
                                <th className="d-print-none">Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {deTai.map((d, idx) => (
                                <tr key={d.id}>
                                    <td>{idx + 1}</td>
                                    <td>
                                        <strong>{d.tenNhiemVu}</strong>
                                        {d.maSoCapQuanLy && <div className="d-print-none" style={{ fontSize: '11px' }}>Mã số: {d.maSoCapQuanLy}</div>}
                                    </td>
                                    <td>
                                        {(() => {
                                            const val = d.vaiTro;
                                            if (val === 1 || val === '1') return 'CN';
                                            if (val === 2 || val === '2') return 'PCN';
                                            if (val === 3 || val === '3') return 'TK';
                                            if (val === 4 || val === '4') return 'TV';
                                            const found = VAI_TRO_DE_TAI.find(o => o.value === val);
                                            if (found) {
                                                if (found.label.includes('Chủ nhiệm')) return 'CN';
                                                if (found.label.includes('Phó chủ nhiệm')) return 'PCN';
                                                if (found.label.includes('Thư ký')) return 'TK';
                                                if (found.label.includes('Thành viên')) return 'TV';
                                            }
                                            return val;
                                        })()}
                                    </td>
                                    <td>{CAP_DE_TAI.find(o => o.value === d.maSoCapQuanLy)?.label || d.maSoCapQuanLy}</td>
                                    <td>
                                        {(() => {
                                            if (!d.thoiGianTuNgay) return '';
                                            const fTu = formatDateTimeWithoutHour(d.thoiGianTuNgay);
                                            const fDen = d.thoiGianDenNgay ? formatDateTimeWithoutHour(d.thoiGianDenNgay) : '';
                                            const getDisplay = (dateStr) => {
                                                if (!dateStr) return '';
                                                const parts = dateStr.split('/');
                                                if (parts.length === 3) {
                                                    if (parts[0] === '01' && parts[1] === '01') return parts[2];
                                                    return `${parts[1]}/${parts[2]}`;
                                                }
                                                return dateStr;
                                            };
                                            const tuDisplay = getDisplay(fTu);
                                            const denDisplay = getDisplay(fDen);
                                            return denDisplay ? `${tuDisplay} - ${denDisplay}` : tuDisplay;
                                        })()}
                                    </td>
                                    <td>
                                        {d.thoiGianNghiemThu && <div>{formatDateTimeWithoutHour(d.thoiGianNghiemThu)}</div>}
                                        <div>
                                            {(() => {
                                                const val = d.xepLoaiKetQua;
                                                if (val === 1 || val === '1') return 'Xuất sắc';
                                                const found = XEP_LOAI_KET_QUA.find(o => o.value === val);
                                                return found ? found.label : (val || 'Chưa nghiệm thu');
                                            })()}
                                        </div>
                                    </td>
                                    <td className="d-print-none">
                                        <RenderFileMinhChung jsonString={d.fileMinhChung} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderApprovalBadge type="DeTai" item={d} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="DeTai" 
                                            item={d}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {deTai.length === 0 && (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted">Không có đề tài nghiên cứu nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <div className="mt-2" style={{ fontSize: '11pt', fontStyle: 'italic' }}>
                        - Các chữ viết tắt: CT: Chương trình; ĐT: Đề tài; CN: Chủ nhiệm; PCN: Phó chủ nhiệm; TK: Thư ký.
                    </div>
                </div>
            </Tab>

            {/* TAB SÁNG CHẾ */}
            <Tab eventKey="sangche" title="2.3 Sáng chế & GPHU">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách bằng độc quyền sáng chế & giải pháp hữu ích</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('SangChe'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo sáng chế
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Tên bằng sáng chế / GPHU</th>
                                <th>Cơ quan cấp</th>
                                <th>Ngày cấp</th>
                                <th>Vai trò sáng chế</th>
                                <th>Số tác giả</th>
                                <th>Minh chứng</th>
                                <th>Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sangChe.map(s => (
                                <tr key={s.id}>
                                    <td><strong>{s.tenBangSangChe}</strong></td>
                                    <td>{s.tenCoQuanCap}</td>
                                    <td>{formatDateTimeWithoutHour(s.ngayThangNamCap)}</td>
                                    <td>{VAI_TRO_SANG_CHE.find(o => o.value === s.vaiTroTacGia)?.label || s.vaiTroTacGia}</td>
                                    <td>{s.soTacGia}</td>
                                    <td>
                                        <RenderFileMinhChung jsonString={s.fileMinhChung} />
                                    </td>
                                    <td>
                                        <RenderApprovalBadge type="SangChe" item={s} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="SangChe" 
                                            item={s}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {sangChe.length === 0 && (
                                <tr>
                                    <td colSpan={8} className="text-center text-muted">Không có sáng chế / giải pháp hữu ích nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Tab>

            {/* TAB GIẢI THƯỞNG NCKH */}
            <Tab eventKey="giaithuong" title="2.4 Giải thưởng NCKH">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách các giải thưởng nghiên cứu khoa học</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('GiaiThuong'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo giải thưởng
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Giải thưởng khoa học công nghệ</th>
                                <th>Năm nhận</th>
                                <th>Cấp công nhận</th>
                                <th>Minh chứng</th>
                                <th>Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {giaiThuong.map(g => (
                                <tr key={g.id}>
                                    <td><strong>{g.hinhThucVaNoiDung}</strong></td>
                                    <td>{g.namTangThuong}</td>
                                    <td>{CAP_GIAI_THUONG.find(o => o.value === g.capCongNhan)?.label || g.capCongNhan}</td>
                                    <td>
                                        <RenderFileMinhChung jsonString={g.fileMinhChung} />
                                    </td>
                                    <td>
                                        <RenderApprovalBadge type="GiaiThuong" item={g} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="GiaiThuong" 
                                            item={g}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {giaiThuong.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Không có giải thưởng NCKH nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Tab>

            {/* TAB SÁCH CHUYÊN KHẢO / GIÁO TRÌNH */}
            <Tab eventKey="sach" title="3.1 Sách xuất bản">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách giáo trình, sách chuyên khảo đã xuất bản</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('Sach'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo sách
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Tên sách</th>
                                <th>Nhà xuất bản</th>
                                <th>Phân loại sách</th>
                                <th>Năm xuất bản</th>
                                <th>Vai trò biên soạn</th>
                                <th>Số chương biên soạn</th>
                                <th>Phần viết (Trang)</th>
                                <th>Xác nhận</th>
                                <th>Minh chứng</th>
                                <th>Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sach.map(s => (
                                <tr key={s.id}>
                                    <td><strong>{s.tenSach}</strong></td>
                                    <td>{s.nhaXuatBan}</td>
                                    <td>{LOAI_SACH.find(o => o.value === s.loaiSach)?.label || s.loaiSach}</td>
                                    <td>{s.namXuatBan}</td>
                                    <td><span className="text-success font-weight-bold">{VAI_TRO_SACH.find(o => o.value === s.vaiTro)?.label || s.vaiTro}</span> <br />({s.soTacGia} tác giả)</td>
                                    <td>{s.soChuongSach || '-'}</td>
                                    <td>Trang {s.phanBienSoanTuTrang} - {s.phanBienSoanDenTrang}</td>
                                    <td>{s.xacNhanCoSo}</td>
                                    <td>
                                        <RenderFileMinhChung jsonString={s.fileMinhChung} />
                                    </td>
                                    <td>
                                        <RenderApprovalBadge type="Sach" item={s} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="Sach" 
                                            item={s}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {sach.length === 0 && (
                                <tr>
                                    <td colSpan={11} className="text-center text-muted">Không có sách / giáo trình nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Tab>

            {/* TAB HƯỚNG DẪN HỌC VIÊN */}
            <Tab eventKey="huongdan" title="3.2 Hướng dẫn học viên">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách hướng dẫn học viên nghiên cứu sinh, thạc sĩ, nội trú</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('HuongDanHocVien'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo hướng dẫn
                        </Button>
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Học viên</th>
                                <th>Bậc học viên</th>
                                <th>Tên đề tài luận văn/luận án</th>
                                <th>Cơ sở đào tạo</th>
                                <th>Trách nhiệm HD</th>
                                <th>Thời điểm bảo vệ</th>
                                <th>Thời gian hướng dẫn</th>
                                <th>Thời gian đào tạo (QĐ)</th>
                                <th>Minh chứng</th>
                                <th>Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {huongDanHocVien.map(h => (
                                <tr key={h.id}>
                                    <td><strong>{h.hoTenHocVien}</strong></td>
                                    <td>{BAC_HOC_VIEN.find(o => o.value === h.doiTuong)?.label || h.doiTuong}</td>
                                    <td>{h.tenDeTai}</td>
                                    <td>{h.coSoDaoTao}</td>
                                    <td><span className="text-info font-weight-bold">{TRACH_NHIEM_HD.find(o => o.value === h.trachNhiemHuongDan)?.label || h.trachNhiemHuongDan}</span></td>
                                    <td>{h.thoiDiemBaoVe || '-'}</td>
                                    <td>{h.thoiGianHuongDanTu && h.thoiGianHuongDanDen ? `${formatDateTimeWithoutHour(h.thoiGianHuongDanTu)} - ${formatDateTimeWithoutHour(h.thoiGianHuongDanDen)}` : '-'}</td>
                                    <td>{h.thoiGianDaoTaoTu && h.thoiGianDaoTaoDen ? `${formatDateTimeWithoutHour(h.thoiGianDaoTaoTu)} - ${formatDateTimeWithoutHour(h.thoiGianDaoTaoDen)}` : '-'}</td>
                                    <td>
                                        <RenderFileMinhChung jsonString={h.fileMinhChung} />
                                    </td>
                                    <td>
                                        <RenderApprovalBadge type="HuongDanHocVien" item={h} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="HuongDanHocVien" 
                                            item={h}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {huongDanHocVien.length === 0 && (
                                <tr>
                                    <td colSpan={10} className="text-center text-muted">Không có dữ liệu hướng dẫn học viên</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Tab>

            {/* TAB GIẢI THƯỞNG ĐÀO TẠO */}
            <Tab eventKey="giaithuongdao-tao" title="3.3 Giải thưởng Đào tạo">
                <div className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="font-weight-bold text-secondary mb-0">Danh sách các giải thưởng về giảng dạy và đào tạo</h5>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            onClick={() => { setSelectedItem({}); setActiveModal('GiaiThuongDaoTao'); }} 
                            className="d-print-none"
                        >
                            <PlusOutlined /> Khai báo giải thưởng
                        </Button>
                    </div>
                    
                    {/* BẢNG HIỂN THỊ TRÊN WEB (ẨN KHI IN) */}
                    <Table striped bordered hover responsive className="d-print-none">
                        <thead className="bg-light">
                            <tr>
                                <th>Giải thưởng giảng dạy / đào tạo</th>
                                <th>Năm nhận</th>
                                <th>Cấp công nhận</th>
                                <th>Minh chứng</th>
                                <th>Phê duyệt</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {giaiThuongDaoTao.map(g => (
                                <tr key={g.id}>
                                    <td><strong>{g.tenGiaiThuong}</strong></td>
                                    <td>{g.namTangThuong}</td>
                                    <td>{CAP_GIAI_THUONG.find(o => o.value === g.capCongNhan)?.label || g.capCongNhan}</td>
                                    <td>
                                        <RenderFileMinhChung jsonString={g.fileMinhChung} />
                                    </td>
                                    <td>
                                        <RenderApprovalBadge type="GiaiThuongDaoTao" item={g} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="GiaiThuongDaoTao" 
                                            item={g}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            handleRevoke={handleRevoke}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {giaiThuongDaoTao.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Không có giải thưởng giảng dạy nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    {/* DANH SÁCH HIỂN THỊ KHI IN */}
                    <div className="d-none d-print-block">
                        <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                            3.3. Giải thưởng về đào tạo (nếu có):
                        </div>
                        {giaiThuongDaoTao.length > 0 ? (
                            <div style={{ paddingLeft: '15px' }}>
                                {giaiThuongDaoTao.map((g, idx) => (
                                    <div key={g.id} className="mb-2" style={{ fontSize: '11pt', lineHeight: '1.6' }}>
                                        <strong>{idx + 1}.</strong> {g.tenGiaiThuong}, Năm: {g.namTangThuong}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="font-italic" style={{ paddingLeft: '15px', fontSize: '11pt' }}>Không có</div>
                        )}
                    </div>
                </div>
            </Tab>
        </Tabs>
    );
};

export default AchievementTabs;
